/**
 * Main Blog — tag filtering + staggered grid layout
 * Ported directly from the source's inline <script>. Logic is unchanged;
 * only cleanup (no console.log stubs, consistent formatting).
 *
 * This file intentionally supports two template variants that shared this
 * script in the source:
 *   - Grid view (what this conversion's section markup renders): tag
 *     filtering + staggered every-other-item layout on desktop.
 *   - List view (`.articles-grid` absent, `.blog-article-item` present):
 *     AJAX "Load More" pagination via Shopify's section-rendering endpoint.
 * The section this conversion ships renders grid view, so the list-view
 * branch is inert here (its own `isListView` check just never becomes
 * true) — it's kept because the source clearly intended this file to be
 * shared across both blog template variants. Delete that block if you
 * don't have a separate list-view blog template using it.
 */
document.addEventListener('DOMContentLoaded', function () {
  var filterLinks = document.querySelectorAll('.filter-link');
  var isListView = document.querySelector('.articles-grid') === null;
  var gridItems = document.querySelectorAll('.grid-item');
  var listItems = document.querySelectorAll('[data-tags]:not(.grid-item)');
  var items = isListView ? listItems : gridItems;

  // ---- Load More (list view only) ----
  if (isListView) {
    var articlesList = document.querySelector('.articles-list');
    var loadMoreBtn = document.querySelector('.load-more-articles-btn');
    var allArticles = document.querySelectorAll('.blog-article-item');
    var articlesPerLoad = 10;
    var currentlyVisible = 10;
    var isLoadingMore = false;
    var currentPage = articlesList ? parseInt(articlesList.dataset.currentPage, 10) || 1 : 1;
    var totalPages = articlesList ? parseInt(articlesList.dataset.totalPages, 10) || 1 : 1;
    var currentPageSize = articlesList ? parseInt(articlesList.dataset.currentPageSize, 10) || 0 : 0;
    var itemsPerPage = articlesList ? parseInt(articlesList.dataset.itemsPerPage, 10) || 250 : 250;
    var nextPageUrl = loadMoreBtn ? loadMoreBtn.dataset.nextPageUrl : null;
    var buttonText = loadMoreBtn ? loadMoreBtn.dataset.buttonText || 'Load More Articles' : 'Load More Articles';

    var totalArticlesAvailable = 0;
    if (currentPage === totalPages && currentPageSize > 0) {
      totalArticlesAvailable = (totalPages - 1) * itemsPerPage + currentPageSize;
    } else {
      totalArticlesAvailable = totalPages * itemsPerPage;
    }

    if (loadMoreBtn && allArticles.length > 0) {
      allArticles.forEach(function (article, index) {
        if (index >= articlesPerLoad) {
          article.classList.add('hidden-article');
        }
      });

      if (allArticles.length <= articlesPerLoad && !nextPageUrl) {
        loadMoreBtn.style.display = 'none';
      }

      loadMoreBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        if (isLoadingMore) return;

        var currentPageArticles = Array.from(allArticles);
        var remainingArticles = currentPageArticles.length - currentlyVisible;

        if (remainingArticles < articlesPerLoad && nextPageUrl && currentPage < totalPages) {
          isLoadingMore = true;
          loadMoreBtn.classList.add('loading');
          loadMoreBtn.textContent = 'Loading...';

          try {
            var separator = nextPageUrl.includes('?') ? '&' : '?';
            var fetchUrl = nextPageUrl + separator + 'section_id=main-blog';
            var response = await fetch(fetchUrl);
            if (!response.ok) throw new Error('Failed to load articles');

            var responseData = await response.text();
            var html = responseData;

            try {
              var jsonData = JSON.parse(responseData);
              html = jsonData.sections?.['main-blog'] || jsonData['main-blog'] || Object.values(jsonData)[0] || html;
            } catch (err) {
              // Not JSON — use the HTML response directly.
            }

            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            var newArticlesList =
              doc.querySelector('#shopify-section-main-blog .articles-list') || doc.querySelector('.articles-list');

            if (!newArticlesList) {
              var sectionWrapper = doc.querySelector('#shopify-section-main-blog') || doc.querySelector('[id^="shopify-section-"]');
              if (sectionWrapper) {
                var sectionDoc = parser.parseFromString(sectionWrapper.innerHTML, 'text/html');
                newArticlesList = sectionDoc.querySelector('.articles-list');
              }
            }

            if (newArticlesList) {
              var newArticles = newArticlesList.querySelectorAll('.blog-article-item');
              var newNextPageUrl = newArticlesList.querySelector('.load-more-articles-btn')?.dataset.nextPageUrl || null;

              currentPage = parseInt(newArticlesList.dataset.currentPage, 10) || currentPage + 1;
              totalPages = parseInt(newArticlesList.dataset.totalPages, 10) || totalPages;
              currentPageSize = parseInt(newArticlesList.dataset.currentPageSize, 10) || currentPageSize;
              nextPageUrl = newNextPageUrl;

              if (currentPage === totalPages && currentPageSize > 0) {
                totalArticlesAvailable = (totalPages - 1) * itemsPerPage + currentPageSize;
              } else {
                totalArticlesAvailable = totalPages * itemsPerPage;
              }

              newArticles.forEach(function (article) {
                var articleClone = article.cloneNode(true);
                articleClone.classList.add('hidden-article');
                articlesList.insertBefore(articleClone, loadMoreBtn.parentElement);
              });

              allArticles = document.querySelectorAll('.blog-article-item');

              if (nextPageUrl) {
                loadMoreBtn.dataset.nextPageUrl = nextPageUrl;
              } else {
                loadMoreBtn.removeAttribute('data-next-page-url');
              }
            } else {
              nextPageUrl = null;
              loadMoreBtn.removeAttribute('data-next-page-url');
            }
          } catch (error) {
            console.error('Error loading more articles:', error);
            nextPageUrl = null;
            loadMoreBtn.removeAttribute('data-next-page-url');
          } finally {
            isLoadingMore = false;
            loadMoreBtn.classList.remove('loading');
            loadMoreBtn.textContent = buttonText;
          }
        }

        var nextBatch = currentlyVisible + articlesPerLoad;
        var articlesToShow = Array.from(allArticles).slice(currentlyVisible, nextBatch);

        if (articlesToShow.length > 0) {
          articlesToShow.forEach(function (article) {
            article.classList.remove('hidden-article');
          });
          currentlyVisible += articlesToShow.length;

          if (currentlyVisible >= allArticles.length && !nextPageUrl) {
            loadMoreBtn.style.display = 'none';
          }
        } else {
          loadMoreBtn.style.display = 'none';
        }
      });
    }
  }

  // ---- Staggered layout (grid view only) ----
  function updateStaggeredLayout() {
    if (isListView) return;
    var visibleItems = Array.from(gridItems).filter(function (item) {
      return item.style.display !== 'none' && item.style.opacity !== '0';
    });

    visibleItems.forEach(function (item, index) {
      if (window.innerWidth > 767) {
        if (index % 2 === 1) {
          item.style.setProperty('margin-top', '10rem', 'important');
        } else {
          item.style.setProperty('margin-top', '0', 'important');
        }
      } else {
        item.style.setProperty('margin-top', '', 'important');
      }
    });
  }

  // ---- Tag filtering ----
  filterLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var filterValue = this.getAttribute('data-filter');

      var isDarkMode = document.querySelector('#articles-grid.is-dark') !== null;
      filterLinks.forEach(function (l) {
        var span = l.querySelector('span');
        span.classList.remove(
          'is-active',
          'border-solid',
          'border-b-2',
          'border-black',
          'text-black',
          'border-white',
          'text-white',
          'pointer-events-none'
        );
        l.classList.remove('active');
      });

      this.classList.add('active');
      var activeSpan = this.querySelector('span');
      if (isDarkMode) {
        activeSpan.classList.add('is-active', 'border-solid', 'border-b-2', 'border-white', 'text-white', 'pointer-events-none');
      } else {
        activeSpan.classList.add('is-active', 'border-solid', 'border-b-2', 'border-black', 'text-black', 'pointer-events-none');
      }

      items.forEach(function (item) {
        if (isListView) {
          item.style.display = 'none';
        } else {
          item.style.display = 'none';
          item.style.opacity = '0';
          item.style.transform = 'scale(0.8)';
        }
      });

      var visibleItems = [];
      items.forEach(function (item) {
        var itemTags = item.getAttribute('data-tags');
        if (filterValue === 'all' || itemTags.includes(filterValue)) {
          visibleItems.push(item);
        }
      });

      if (!isListView) {
        visibleItems.forEach(function (item, index) {
          if (window.innerWidth > 767) {
            if (index % 2 === 1) {
              item.style.setProperty('margin-top', '10rem', 'important');
            } else {
              item.style.setProperty('margin-top', '0', 'important');
            }
          } else {
            item.style.setProperty('margin-top', '', 'important');
          }
        });
      }

      setTimeout(
        function () {
          visibleItems.forEach(function (item) {
            item.style.display = 'block';
            if (!isListView) {
              setTimeout(function () {
                item.style.opacity = '1';
                item.style.transform = 'scale(1)';
              }, 10);
            }
          });
        },
        isListView ? 0 : 100
      );

      var currentUrl = new URL(window.location);
      if (filterValue === 'all') {
        currentUrl.pathname = currentUrl.pathname.replace(/\/tagged\/[^/]+/, '');
      } else {
        currentUrl.pathname = currentUrl.pathname.replace(/\/tagged\/[^/]+/, '/tagged/' + filterValue);
      }
      window.history.pushState({}, '', currentUrl);
    });
  });

  if (!isListView) {
    window.addEventListener('resize', updateStaggeredLayout);
    updateStaggeredLayout();
  }

  // ---- Pin heading until the articles list ends (list view, desktop only) ----
  var heading = document.querySelector('.list-view-heading');
  var wrapper = document.querySelector('.articles-list');
  var pinTrigger = null;

  function setupPin() {
    if (!heading || !wrapper || typeof ScrollTrigger === 'undefined') return;
    if (pinTrigger) pinTrigger.kill();
    if (!window.matchMedia('(min-width: 1024px)').matches) return;

    var headingOffset = heading.offsetTop;
    var headingHeight = heading.offsetHeight;
    pinTrigger = ScrollTrigger.create({
      trigger: wrapper,
      start: 'top top+=' + headingOffset,
      endTrigger: '.articles-list',
      end: 'bottom top+=' + (headingHeight + headingOffset),
      pin: heading,
      pinSpacing: false,
    });
  }

  setupPin();
  window.matchMedia('(min-width: 1024px)').addEventListener('change', function () {
    setupPin();
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  });
});